import { VStack } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const QuestStepsSectionWrapper = VStack.withConfig({
  padding: '$4',
  space: '$4',
  borderRadius: 'lg',
  borderWidth: '1px',
  borderColor: getDesignToken('background-contrast-loyalty-reversed'),
});
